var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgA2Hs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 60,
    viewBox: "0 0 40 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 36.5C18.5 37.3284 19.1716 38 20 38C20.8284 38 21.5 37.3284 21.5 36.5H20H18.5ZM21.0607 0.43934C20.4749 -0.146447 19.5251 -0.146447 18.9393 0.43934L9.3934 9.98528C8.80761 10.5711 8.80761 11.5208 9.3934 12.1066C9.97918 12.6924 10.9289 12.6924 11.5147 12.1066L20 3.62132L28.4853 12.1066C29.0711 12.6924 30.0208 12.6924 30.6066 12.1066C31.1924 11.5208 31.1924 10.5711 30.6066 9.98528L21.0607 0.43934ZM20 36.5H21.5L21.5 1.5H20H18.5L18.5 36.5H20Z",
    fill: "#3C97FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 19.5C37.7614 19.5 40 21.7386 40 24.5V54.5C40 57.2614 37.7614 59.5 35 59.5H5C2.23858 59.5 0 57.2614 0 54.5V24.5C0 21.7386 2.23858 19.5 5 19.5H12V22.5H5C3.89543 22.5 3 23.3954 3 24.5V54.5C3 55.6046 3.89543 56.5 5 56.5H35C36.1046 56.5 37 55.6046 37 54.5V24.5C37 23.3954 36.1046 22.5 35 22.5H28V19.5H35Z",
    fill: "#3C97FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgA2Hs);
export default __webpack_public_path__ + "static/media/a2hs.9a02f0a60cc8376fae6d683c5b03408c.svg";
export { ForwardRef as ReactComponent };